import { File, FileStatus } from "../files.types";
import styled from "styled-components";

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StatusBadge = styled.div<{ status: FileStatus }>`
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  text-transform: capitalize;
  background-color: ${({ status, theme }) => {
    const isDark = theme.palette.mode === "dark";
    switch (status) {
      case FileStatus.ACTIVE:
        return isDark ? "rgba(46, 125, 50, 0.2)" : "#E6F4EA";
      case FileStatus.ARCHIVED:
        return isDark ? "rgba(158, 158, 158, 0.2)" : "#F1F3F4";
      case FileStatus.UPLOADING:
        return isDark ? "rgba(237, 108, 2, 0.2)" : "#FFF3E0";
      case FileStatus.FAILED:
        return isDark ? "rgba(211, 47, 47, 0.2)" : "#FCE8E6";
      default:
        return isDark ? "rgba(158, 158, 158, 0.2)" : "#F1F3F4";
    }
  }};
  color: ${({ status, theme }) => {
    const isDark = theme.palette.mode === "dark";
    switch (status) {
      case FileStatus.ACTIVE:
        return isDark ? "#81C784" : "#137333";
      case FileStatus.ARCHIVED:
        return isDark ? "#BDBDBD" : "#5F6368";
      case FileStatus.UPLOADING:
        return isDark ? "#FFB74D" : "#E65100";
      case FileStatus.FAILED:
        return isDark ? "#E57373" : "#C5221F";
      default:
        return isDark ? "#BDBDBD" : "#5F6368";
    }
  }};
  border: 1px solid
    ${({ status, theme }) => {
      const isDark = theme.palette.mode === "dark";
      switch (status) {
        case FileStatus.ACTIVE:
          return isDark ? "rgba(46, 125, 50, 0.3)" : "rgba(19, 115, 51, 0.2)";
        case FileStatus.ARCHIVED:
          return isDark ? "rgba(158, 158, 158, 0.3)" : "rgba(95, 99, 104, 0.2)";
        case FileStatus.UPLOADING:
          return isDark ? "rgba(237, 108, 2, 0.3)" : "rgba(230, 81, 0, 0.2)";
        case FileStatus.FAILED:
          return isDark ? "rgba(211, 47, 47, 0.3)" : "rgba(197, 34, 31, 0.2)";
        default:
          return isDark ? "rgba(158, 158, 158, 0.3)" : "rgba(95, 99, 104, 0.2)";
      }
    }};
`;

export const CaseFileStatusComponent = ({ file }: { file: File }) => {
  return (
    <StyledContainer>
      <StatusBadge status={file.status}>{file.status}</StatusBadge>
    </StyledContainer>
  );
};
